'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-null-or-undefined.js
// module id = 127
// module chunks = 22